<template>
  <!-- act-item .pi -->
  <!-- <div>
        <div v-if="ActData.length">
            <div class="pi">
                <div class="pi-wrap" v-for="(item, index) in ActData" :key="'act-item-' + index">
                    <div class="wrap" @click="linkToAct(item)">
                        <div class="photo">
                            <img :src="item.banner[0]" alt="" v-if="item.banner[0]">
                            <img src="@/assets/img/empty.png" alt="" v-else>
                        </div>
                        <div class="title">
                            <h3 :title="item.nameEn">{{ item.nameEn }}</h3>
                            <p style="padding-left: 12px;" class="title-line">
                                <span style="white-space: normal;">{{ item.compNameEn }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="m-page" v-if="totalCount > 20">
                <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount"
                    @on-change="changePage" @on-page-size-change="changePageSize" />
            </div>
        </div>
        <div class="no-msg" v-else>
            No Data
        </div>
    </div> -->

  <div class="pro-item">
    <div
      v-if="ActData && ActData.length > 0"
      @click="linkToAct(item)"
      class="pro-item-wrap"
      v-for="(item, index) in ActData"
      :key="'pro-wrap-' + index"
    >
      <p :title="item.nameEn" v-if="item.nameEn" class="wrap-title">{{ item.nameEn }}</p>
      <p :title="item.name" v-else class="wrap-title">{{ item.name }}</p>
      <img v-if="item.banner[0]" :src="item.banner[0]" />
      <img src="@assets/img/empty.png" v-else />
      <div class="wrap-com">
        <p v-if="item.compNameEn" :title="item.compNameEn">{{ item.compNameEn }}</p>
        <p v-else :title="item.compName">{{ item.compName }}</p>
        <!-- <i
          style="color: #b1262d"
          class="icon iconfont icon-love"
          @click.stop="cancelCollect(item)"
          v-if="item.isFollow"
        ></i>
        <i
          style="color: #bfbfbf"
          class="icon iconfont icon-guanzhu-xian"
          @click.stop="addCollect(item)"
          v-else
        ></i> -->
      </div>
    </div>
    <div class="no-msg" v-else>No Data</div>
    <div class="m-page" v-if="totalCount > 20">
      <Page
        show-total
        show-elevator
        :page-size="pageSize"
        :current="pageIndex"
        :total="totalCount"
        @on-change="changePage"
        @on-page-size-change="changePageSize"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "act-item",
  props: ["topic", "nameEn", "typeId"],
  data() {
    return {
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0, // 总数据
      ActData: [],
      // topic: -1, // -4：免费报名，-3：新发布，-2：热搜，-1:所有，0:Normal=不置顶，1:Hot=热门，2:Recommend=推荐"
      donetTip: false, //数据是否加载完毕
      searchContent: "",
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
    }),
    condition() {
      //分页获取条件
      return {
        // ExhibitionId: this.exhibitionId,
        // ExhibitionId: '11566CC1-CE09-46F5-B886-701CAACED3CE',
        ExhibitionIdStr:
          "ab24aee3-ad4f-438c-9f8f-4816d2ef0865,a3741b45-d5ee-46dc-8a94-2e2577ad5ee0,ebd24211-4119-4b47-afb2-9647c325ebab,c17e019f-3e00-4f5e-b46f-d0ed2439fe0e",
        PageSize: this.pageSize,
        PageIndex: this.pageIndex,
        ProductName: localStorage.getItem("searchTextTag"),
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: this.nameEn == -1 ? "Name" : "Category",
                  Value:
                    this.nameEn == -1
                      ? "%" + this.searchContent + "%"
                      : "%" + this.nameEn + "%",
                },
              },
              // {
              //     type: 1,
              //     wheres: {
              //         WhereOperator: 6,
              //         Label: 'Tag',
              //         Value: '%臻品荟%'
              //     }
              // }
            ],
          },
        },
      };
    },
    condition1() {
      //分页获取条件
      return {
        // ExhibitionId: this.exhibitionId,
        // ExhibitionId: '11566CC1-CE09-46F5-B886-701CAACED3CE',
        ExhibitionIdStr:
          "ab24aee3-ad4f-438c-9f8f-4816d2ef0865,a3741b45-d5ee-46dc-8a94-2e2577ad5ee0,ebd24211-4119-4b47-afb2-9647c325ebab,c17e019f-3e00-4f5e-b46f-d0ed2439fe0e",

        PageSize: this.pageSize,
        PageIndex: this.pageIndex,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "Name",
                  Value: this.searchContent + "%",
                },
              },
              // {
              //     type: 1,
              //     wheres: {
              //         WhereOperator: 6,
              //         Label: 'Tag',
              //         Value: '%臻品荟%'
              //     }
              // }
            ],
          },
        },
      };
    },
  },
  watch: {
    nameEn(val) {
      this.select(val);
    },
  },
  created() {
    this.init();
    this.huoqu();
  },
  methods: {
    // 获取
    async huoqu() {
      let opt = {
        tagId: "e2f055e2-4cec-4875-84c2-2624526391ae",
        dataType: "page",
        pageType: "pcen",
        countType: "preview",
        productId: null,
        categoryId: null,
        userId: null,
        ips: sessionStorage.getItem("ip") ? sessionStorage.getItem("ip") : "127.0.0.1",
      };
      let comments = await this.$service.postTagCount(this, opt);
    },

    init() {
      this.getActList();
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
      console.log("changePage: ", e);
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
      console.log("changePageSize: ", e);
    },
    async linkToAct(item) {
      // console.log(item,'item');
      let opt = {
        tagId: "e2f055e2-4cec-4875-84c2-2624526391ae",
        dataType: "product",
        pageType: "pcen",
        countType: "preview",
        productId: item.id,
        categoryId: null,
        userId: null,
        ips: sessionStorage.getItem("ip") ? sessionStorage.getItem("ip") : "127.0.0.1",
      };
      let comments = await this.$service.postTagCount(this, opt);

      this.$router.push(`/pro-detailsEn/${item.id}?typeName=2&compId=${item.compId}`);
    },
    async getActList() {
      this.ActData = [];
      this.donetTip = false;
      let opt={
        // ExhibitionId: this.exhibitionId,
        // ExhibitionId: '11566CC1-CE09-46F5-B886-701CAACED3CE',
        ExhibitionIdStr:
          "ab24aee3-ad4f-438c-9f8f-4816d2ef0865,a3741b45-d5ee-46dc-8a94-2e2577ad5ee0,ebd24211-4119-4b47-afb2-9647c325ebab,c17e019f-3e00-4f5e-b46f-d0ed2439fe0e",
        PageSize: this.pageSize,
        PageIndex: this.pageIndex,
        ProductName: localStorage.getItem("searchTextTag"),
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: this.nameEn == -1 ? "Name" : "Category",
                  Value:
                    this.nameEn == -1
                      ? "%" + this.searchContent + "%"
                      : "%" + this.nameEn + "%",
                },
              },
            ],
          },
        },
      };
      let result = await this.$service.getProductLive(
        this,
        // this.nameEn == "全部" ? this.condition1 : this.condition,
        opt,
        this.topic,
        "e2f055e2-4cec-4875-84c2-2624526391ae"
      );
      //    let result = await this.$service.getProductLive(this, this.nameEn == '全部' ? this.condition1 : this.condition, this.topic, 'e2f055e2-4cec-4875-84c2-2624526391ae');
      this.ActData = result.items;
      this.pageIndex = result.pageIndex;
      this.pageSize = result.pageSize;
      this.totalCount = result.totalCount;
    },

    async select(type) {
      if (this.typeId == "1") {
        let opt = {
          tagId: "e2f055e2-4cec-4875-84c2-2624526391ae",
          dataType: "page",
          pageType: "pcen",
          countType: "preview",
          productId: null,
          categoryId: null,
          userId: null,
          ips: sessionStorage.getItem("ip") ? sessionStorage.getItem("ip") : "127.0.0.1",
        };
        let comments = await this.$service.postTagCount(this, opt);
      } else {
        let opt = {
          tagId: "e2f055e2-4cec-4875-84c2-2624526391ae",
          dataType: "page",
          pageType: "pcen",
          countType: "preview",
          productId: null,
          categoryId: this.typeId,
          userId: null,
          ips: sessionStorage.getItem("ip") ? sessionStorage.getItem("ip") : "127.0.0.1",
        };
        let comments = await this.$service.postTagCount(this, opt);
      }

      this.pageIndex = 1;
      this.pageSize = 20;
      //   this.topic = type;
      this.getActList();
    },
  },
};
</script>

<style scoped lang="scss">
.m-page {
  padding-bottom: 50px;
  text-align: center;
}

.pi {
  margin-top: 20px;
  margin-bottom: 50px;
  overflow: hidden;

  &-wrap {
    cursor: pointer;
    display: block;
    width: 25%;
    float: left;
    background-color: #f5f5f5;
    overflow: hidden;
    padding-bottom: 10px;
    padding-right: 20px;
    color: #ccc;

    &:nth-of-type(4n) {
      padding-right: 0px;
    }
  }
}
</style>
<style scoped lang="scss">
@import "@assets/scss/utils.scss";

.wrap {
  width: 100%;
  height: 299px;
  border-radius: 3px;
  background-color: #fff;
  position: relative;
  margin-bottom: 20px;
  cursor: pointer;
}

.wrap .photo {
  height: 190px;
  overflow: hidden;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;

  img {
    width: 100%;
    height: 100%;
  }
}

.wrap .title {
  height: 109px;
  overflow: hidden;
}

.wrap .title h3 {
  font-size: 14px;
  padding: 0 14px;
  color: #333;
  line-height: 18px;
  margin-bottom: 11px;
  margin-top: 20px;
  @include text-ellipsis();
}

.wrap .title {
  span {
    font-size: 14px;
    color: #999;
    line-height: 26px;
    padding-left: 4px;
  }

  .title-line {
    display: flex;
    align-items: center;

    span {
      width: calc(100% - 1px);
      padding-right: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.wrap .icon2 {
  min-width: 68px;
  height: 24px;
  background-color: #1890ff;
  border-radius: 2px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 24px;
  position: absolute;
  top: 172px;
  left: 14px;
  padding: 0 4px;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.no-msg {
  height: 200px;
  line-height: 200px;
  text-align: center;
  width: 100%;
  display: table;
}

@media (min-width: 799px) {
  .pro-item {
    background-color: #fff;
    padding: 20px 0 20px 20px;
    margin-bottom: 50px;
    &-wrap {
      width: 430px;
      height: 380px;
      border: solid 2px #f5f5f5;
      margin: 0 20px 20px 0;
      cursor: pointer;
      display: inline-block;
      font-size: 0;
      transition: 0.2s;
      &:hover {
        transform: scale(1.1);
      }
      .wrap-title {
        width: 100%;
        height: 48px;
        line-height: 48px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0 15px;
        font-size: 16px;
        color: #024c8b;
      }
      img {
        width: 100%;
        height: calc(100% - 115px);
        padding: 0 15px;
        margin-bottom: 15px;
      }
      .wrap-com {
        width: 100%;
        height: 52px;
        display: flex;
        align-items: center;
        padding: 0 10px 0 15px;
        background-color: #f5f5f5;
        font-size: 14px;
        color: #333;
        p {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        i {
          font-size: 24px;
        }
      }
    }
    .m-page {
      width: 100%;
      padding: 20px 0;
      text-align: center;
    }
  }
}
@media (max-width: 799px) {
  .pro-item {
    background-color: #fff;
    padding: 0 15px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    &-wrap {
      width: calc(330vw / 7.5);
      border: solid 1px #e5e5e5;
      cursor: pointer;
      display: inline-block;
      margin-bottom: calc(30vw / 7.5);
      padding: calc(30vw / 7.5) 0 0;
      .wrap-title {
        width: 100%;
        height: calc(25vw / 7.5);
        line-height: calc(25vw / 7.5);
        font-family: PingFang-SC-Medium;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: calc(26vw / 7.5);
        color: #333;
        padding: 0 calc(20vw / 7.5);
      }
      img {
        width: 100%;
        height: calc(178vw / 7.5);
        margin: calc(20vw / 7.5) 0;
        padding: 0 calc(20vw / 7.5);
      }
      .wrap-com {
        width: 100%;
        height: calc(64vw / 7.5);
        display: flex;
        align-items: center;
        font-family: PingFang-SC-Medium;
        padding: 0 calc(20vw / 7.5) 0 calc(30vw / 7.5);
        background-color: #f7f7f7;
        font-size: calc(22vw / 7.5);
        color: #333;
        p {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        i {
          font-size: 24px;
        }
      }
    }
    .m-page {
      width: 100%;
      padding: 20px 0;
      text-align: center;
    }
  }
}
</style>

<style lang="scss">
.ivu-message {
  z-index: 1050 !important;
}
</style>
